// Lot 668 — son des directs : activé par défaut ; le spectateur qui coupe le son est mémorisé.
// Lot 671 — le défaut suit le garde-fou admin « live_sound_default » ; un choix explicite du membre (on/off) prime.
import { guardOn } from "@/lib/guards";

const KEY = "yalola.live.sound";

export const liveSoundPref = () => {
  let v = null;
  try { v = localStorage.getItem(KEY); } catch { /* noop */ }
  if (v === "off") return false;
  if (v === "on") return true;
  return guardOn("live_sound_default");
};

export const saveLiveSoundPref = (on) => {
  try { localStorage.setItem(KEY, on ? "on" : "off"); } catch { /* noop */ }
};

// play() d'une vidéo non muette refusé par le navigateur (pas de geste utilisateur) → on bascule en muet pour
// que l'image démarre quand même, et on prévient le lecteur (pastille « Activer le son »).
export const playWithAutoplayFallback = (video, onBlocked) => {
  if (!video?.play) return Promise.resolve(false);
  return video.play().then(() => false).catch((e) => {
    if (video.muted || e?.name !== "NotAllowedError") throw e;
    video.muted = true;
    onBlocked?.();
    return video.play().then(() => true).catch(() => true);
  });
};
